import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { CustomDateRange } from "../filters/CustomDateRange";
import { useAppController, streamOptions } from "../../hooks/useAppController";

const CustomDateRangeRoute: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const controller = useAppController();

  // Check if we came from sales dashboard
  const urlParams = new URLSearchParams(location.search);
  const source = urlParams.get('source');
  const isFromSalesDashboard = source === 'sales-dashboard';

  const handleCancel = () => {
    controller.setStartDate(null);
    controller.setEndDate(null);
    
    // Navigate back to home (sales dashboard options removed)
    history.push("/");
  };

  const handleSubmit = async () => {
    if (isFromSalesDashboard) {
      // For sales dashboard, apply the filter and create the dashboard
      await controller.handleCustomDateRangeSubmit();
      // Optionally navigate to a success page or stay on current page
      // For now, we'll stay on this page to show the success state
    } else {
      // Original behavior
      await controller.handleCustomDateRangeSubmit();
    }
  };

  return (
    <CustomDateRange
      startDate={controller.startDate}
      endDate={controller.endDate}
      setStartDate={controller.setStartDate}
      setEndDate={controller.setEndDate}
      hasDateRange={controller.hasDateRange}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      showFilterSuccess={controller.showFilterSuccess}
      streamOptions={streamOptions}
      formatDate={controller.formatDate}
    />
  );
};

export default CustomDateRangeRoute;
